import SCToggle from "./Toggle";
export default SCToggle;